module.exports = __webpack_public_path__ + "img/logo-general.1037f84c.svg";